import React from 'react'
import { withTranslation } from 'react-i18next'
import FilterPill from '../../shared/FilterPill'
import SearchInput from '../../shared/SearchInput'

export default withTranslation()(function POSFilterBar({
  t, q, onChangeQ, branches = [], branch, onChangeBranch, deviceModels = [], deviceModel, onChangeDeviceModel, status, onChangeStatus
}) {
  const branchOptions = [
    { label: t('pos.management.filters.all_branches'), value: '' },
    ...branches.map(({ id, name }) => ({ label: name, value: id }))
  ]

  const deviceModelOptions = [
    { label: t('pos.management.filters.all_device_models'), value: '' },
    ...deviceModels.map((model) => ({ label: model, value: model }))
  ]

  const statusOptions = [
    { label: t('pos.management.filters.all_statuses'), value: '' },
    { label: t('pos.management.filters.active'), value: 'active' },
    { label: t('pos.management.filters.inactive'), value: 'inactive' }
  ]

  return (
    <div className="flex flex-wrap items-center gap-3 mb-4">
      <SearchInput
        value={q}
        onChange={onChangeQ}
        placeholder={t('pos.management.filters.search_placeholder')}
      />

      <FilterPill
        label={t('pos.management.filters.all_branches')}
        active={branch ? { label: branchOptions.find((option) => `${option.value}` === `${branch}`)?.label } : null}
        options={branchOptions}
        showSearch
        searchPlaceholder={t('pos.management.filters.search_branch_placeholder')}
        onSelect={(option) => onChangeBranch(option.value)}
      />

      <FilterPill
        label={t('pos.management.filters.all_device_models')}
        active={deviceModel ? { label: deviceModel } : null}
        options={deviceModelOptions}
        onSelect={(option) => onChangeDeviceModel(option.value)}
      />

      <FilterPill
        label={t('pos.management.filters.all_statuses')}
        active={status ? { label: statusOptions.find((option) => option.value === status)?.label } : null}
        options={statusOptions}
        onSelect={(option) => onChangeStatus(option.value)}
      />
    </div>
  )
})
